"use client";

import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import type { MouseEventHandler, ReactNode } from 'react';
import { useEffect } from 'react';
import styles from "./Div100Vh.module.css";

//#region [Props]
type Div100VhProps = {
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler;
};
//#endregion

/**
 * https://dev.to/nirazanbasnet/dont-use-100vh-for-mobile-responsive-3o97
 */

//#region [Component]
export default function Div100Vh(t0) {
  const $ = _c(7);
  const {
    className,
    children,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  let t2;
  if ($[1] !== className) {
    t2 = classNames(styles.SDiv100Vh, className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== onClick || $[5] !== t2) {
    t3 = <div className={t2} onClick={onClick}>{children}</div>;
    $[3] = children;
    $[4] = onClick;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
//#endregion
function _temp2() {
  if (!CSS.supports("height", "100dvh")) {
    window?.addEventListener("resize", resizeListener);
    return _temp;
  }
}
function _temp() {
  window?.removeEventListener("resize", resizeListener);
}
const resizeListener = (event: UIEvent) => {
  const doc = document?.documentElement;
  doc?.style?.setProperty('--doc-height', `${window?.innerHeight}px`);
};